
export function transformToString(any) {
  switch (typeof any) {
    case 'object':
      return JSON.stringify(any);
    case 'function':
      return `${any}`;
    default:
      return `${any}`;
  }
}

export function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== '';
}

export function deepClone(value) {
  if (value instanceof Date) return new Date(value.getTime());
  if (Array.isArray(value)) return value.map(deepClone);
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((copy, key) => {
      copy[key] = deepClone(value[key]);
      return copy;
    }, {});
  }
  return value;
}
